import { isOnClient } from '@growth/ssr-utils';

var BROWSER_STORAGE_TYPE = {
  LOCAL_STORAGE: isOnClient ? window.localStorage : '',
  SESSION_STORAGE: isOnClient ? window.sessionStorage : ''
};

var makeExpireTime = function makeExpireTime(sec) {
  if (sec === void 0) {
    sec = 0;
  }

  // take ttl in sec to keep the api same across all other cache utils
  var d = new Date();
  d.setSeconds(d.getSeconds() + sec);
  return d.getTime();
};

var isTimeExpired = function isTimeExpired(time) {
  return new Date().getTime() - time >= 0;
};

function storageAvailable(type) {
  var storage;

  try {
    storage = type;
    var x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return false;
  }
}

var storage = function storage(backed) {
  return {
    setItem: function setItem(key, value, expiryTime) {
      if (!storageAvailable(backed)) return null;

      if (value === undefined) {
        backed.removeItem(key);
      } else {
        var storageValue = {
          value: value
        };

        if (expiryTime) {
          storageValue.timeStamp = makeExpireTime(expiryTime);
        }

        backed.setItem(key, JSON.stringify(storageValue));
      }

      return value;
    },
    getItem: function getItem(key) {
      if (!storageAvailable(backed)) return null;
      var value; // undefined

      var str = backed.getItem(key);

      if (str) {
        try {
          var _JSON$parse = JSON.parse(str),
              respValue = _JSON$parse.value,
              timeStamp = _JSON$parse.timeStamp;

          if (timeStamp && isTimeExpired(timeStamp)) {
            backed.removeItem(key);
          } else {
            value = respValue;
          }
        } catch (e) {
          // console.log(`Error parsing storage ['${ key }']`);
          backed.removeItem(key);
        }
      }

      return value;
    },
    removeItem: function removeItem(key) {
      if (!storageAvailable(backed)) return null;
      return backed.removeItem(key);
    }
  };
};

var getLocalStorage = function getLocalStorage() {
  return storage(BROWSER_STORAGE_TYPE.LOCAL_STORAGE);
};

var getSessionStorage = function getSessionStorage() {
  return storage(BROWSER_STORAGE_TYPE.SESSION_STORAGE);
};

var docLocalStorage = getLocalStorage();
var docSessionStorage = getSessionStorage();

export { docLocalStorage, docSessionStorage };
